import { render, staticRenderFns } from "./component-sue7nhwz.vue?vue&type=template&id=2a8c5bb8&scoped=true&"
import script from "./component-sue7nhwz.vue?vue&type=script&lang=js&"
export * from "./component-sue7nhwz.vue?vue&type=script&lang=js&"
import style0 from "./component-sue7nhwz.vue?vue&type=style&index=0&id=2a8c5bb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8c5bb8",
  null
  
)

export default component.exports